(() => {
  const root = document.getElementById('am-pwa');
  if (!root) return;
  const launch = root.querySelector('[data-pwa-launch]');
  const dialog = root.querySelector('dialog');
  const launcher = root.querySelector('.am-pwa-launcher');
  const nativeHelp = root.querySelector('[data-pwa-native]');
  const iosHelp = root.querySelector('[data-pwa-ios]');
  const androidHelp = root.querySelector('[data-pwa-android]');
  const desktopHelp = root.querySelector('[data-pwa-desktop]');
  const standalone = window.matchMedia('(display-mode: standalone)');
  const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const android = /Android/.test(navigator.userAgent);
  let pending = null;
  const dismissKey = 'am-pwa-dismissed-visit-v1';
  const readDismissed = () => {
    try { return sessionStorage.getItem(dismissKey) === '1'; } catch { return false; }
  };
  const saveDismissed = value => {
    try {
      if (value) sessionStorage.setItem(dismissKey, '1');
      else sessionStorage.removeItem(dismissKey);
    } catch {}
  };
  // Preserve dismissal across internal pages and reloads, reset on a fresh arrival.
  const navigation = performance.getEntriesByType('navigation')[0];
  let internalArrival = false;
  try { internalArrival = !!document.referrer && new URL(document.referrer).origin === location.origin; } catch {}
  if (!internalArrival && navigation?.type !== 'reload' && navigation?.type !== 'back_forward') saveDismissed(false);
  let dismissed = readDismissed();
  let leftPage = false;
  const installedKey = 'am-pwa-installed-v1';
  let knownInstalled = false;
  const rememberInstalled = () => {
    knownInstalled = true;
    try { localStorage.setItem(installedKey, '1'); } catch {}
  };
  const inApp = () => standalone.matches || navigator.standalone === true;
  const forgetInstalled = () => {
    knownInstalled = false;
    try { localStorage.removeItem(installedKey); } catch {}
  };
  const installed = () => {
    if (inApp()) rememberInstalled();
    if (!knownInstalled) {
      try { knownInstalled = localStorage.getItem(installedKey) === '1'; } catch {}
    }
    return knownInstalled;
  };
  const sync = () => {
    // The help dialog remains available from My account even when the pill is hidden.
    root.hidden = false;
    launcher.hidden = installed() || dismissed;
    const accountButton = document.getElementById('am-account-install');
    if (accountButton) accountButton.hidden = inApp();
  };
  sync();
  standalone.addEventListener('change', sync);
  window.addEventListener('beforeinstallprompt', event => {
    event.preventDefault();
    // A real browser install prompt supersedes a stale remembered installation.
    if (inApp()) return;
    forgetInstalled();
    pending = event;
    sync();
    nativeHelp.hidden = false;
  });
  window.addEventListener('appinstalled', () => {
    rememberInstalled();
    pending = null;
    sync();
    if (dialog.open) dialog.close();
  });
  const prompt = async () => {
    const event = pending;
    if (!event) return;
    pending = null;
    nativeHelp.hidden = true;
    if (dialog.open) dialog.close();
    try { await event.prompt(); await event.userChoice; } catch { launch.focus(); }
  };
  const openInstall = (explicit = false) => {
    if (inApp()) { sync(); return; }
    if (explicit) { forgetInstalled(); sync(); }
    else if (installed()) { sync(); return; }
    if (pending) { prompt(); return; }
    iosHelp.hidden = !ios;
    androidHelp.hidden = ios || !android;
    desktopHelp.hidden = ios || android;
    nativeHelp.hidden = !pending;
    if (!dialog.open) dialog.showModal();
  };
  launch.addEventListener('click', () => openInstall());
  nativeHelp.addEventListener('click', prompt);
  root.querySelector('[data-pwa-close]').addEventListener('click', () => dialog.close());
  root.querySelector('[data-pwa-dismiss]').addEventListener('click', () => {
    dismissed = true;
    saveDismissed(true);
    sync();
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  // Safari cannot reliably detect a previously installed Home Screen app.
  // Let the customer explicitly confirm it rather than hiding after opening help.
  const actions = root.querySelector('.am-pwa-actions');
  if (actions) {
    const alreadyInstalled = document.createElement('button');
    alreadyInstalled.type = 'button';
    alreadyInstalled.dataset.pwaAlreadyInstalled = '';
    const language = (document.documentElement.lang || 'es').toLowerCase();
    alreadyInstalled.textContent = language.startsWith('en') ? 'I already installed it'
      : language.startsWith('de') ? 'Bereits installiert' : 'Ya la tengo instalada';
    alreadyInstalled.addEventListener('click', () => {
      rememberInstalled();
      pending = null;
      sync();
      if (dialog.open) dialog.close();
    });
    actions.appendChild(alreadyInstalled);
  }
  window.addEventListener('storage', event => {
    if (event.key === installedKey && event.newValue === '1') {
      knownInstalled = true;
      sync();
      if (dialog.open) dialog.close();
    }
  });
  const account = document.getElementById('am-bottom-account');
  if (account && !document.getElementById('am-account-install')) {
    const button = document.createElement('button');
    button.id = 'am-account-install';
    button.type = 'button';
    button.className = 'am-ac-row am-account-install';
    const language = (document.documentElement.lang || 'es').toLowerCase();
    const label = language.startsWith('en') ? 'Install app'
      : language.startsWith('de') ? 'App installieren' : 'Instalar app';
    button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="2" width="12" height="20" rx="2"/><path d="M12 6v9m-3-3 3 3 3-3M10 19h4"/></svg><span>' + label + '</span><span class="am-ac-arrow" aria-hidden="true">›</span>';
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-controls', 'am-pwa-help');
    button.addEventListener('click', () => {
      const drawer = document.getElementById('am-bottom-dialog');
      if (drawer?.open) drawer.close();
      openInstall(true);
    });
    account.appendChild(button);
    sync();
  }
  const resumeVisit = () => {
    dismissed = false;
    saveDismissed(false);
    sync();
  };
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') { leftPage = true; return; }
    if (document.visibilityState === 'visible' && leftPage) {
      leftPage = false;
      resumeVisit();
    }
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) {
      leftPage = false;
      dismissed = readDismissed();
    }
    sync();
  });
})();